export const SET_PUBLISHED_EVENTS = "SET_PUBLISHED_EVENTS";
export const SET_EVENTS_QUESTION = "SET_EVENTS_QUESTION";
export const SET_CURRENT_EVENT_ID = "SET_CURRENT_EVENT_ID";
export const SET_QUESTIONS_DATA = "SET_QUESTIONS_DATA";
export const SET_UPLOAD_RESPONSE = "SET_UPLOAD_RESPONSE";
export const SET_CURRENT_EVENT_NAME = "SET_CURRENT_EVENT_NAME";
export const SET_UPLOAD_SUCCESS_PENDING = "SET_UPLOAD_SUCCESS_PENDING";
export const SET_TIMER_BOOLEAN = "SET_TIMER_BOOLEAN";
export const SET_ACTIVE_QUES_ID = "SET_ACTIVE_QUES_ID";
export const SET_IS_GET_PUBLISHED_EVENT_PENDING = "SET_IS_GET_PUBLISHED_EVENT_PENDING";
export const SET_IS_GET_QUESTIONS_LIST_PENDING = "SET_IS_GET_QUESTIONS_LIST_PENDING";
export const SET_IS_GET_QUESTION_DATA_PENDING = "SET_IS_GET_QUESTION_DATA_PENDING";
export const SET_IS_SUBMIT_ANSWER_PENDING = "SET_IS_SUBMIT_ANSWER_PENDING";
export const INIT_AUTOEVAL_DIALOG= "INIT_AUTOEVAL_DIALOG";
export const SET_PROGRESS_VALUE = "SET_PROGRESS_VALUE";
export const SET_PROGRESS_NAME = "SET_PROGRESS_NAME";
export const SET_AUTOEVAL_RESULT_STATUS = "SET_AUTOEVAL_RESULT_STATUS";
export const SET_AUTOEVAL_RESULT_STRING = "SET_AUTOEVAL_RESULT_STRING";
export const LOAD_INPUTS = "LOAD_INPUTS";
export const START_NEXT_INPUT = "START_NEXT_INPUT";
export const ANIMATE_STEP = "ANIMATE_STEP";
export const STOP_ANIMATION = "STOP_ANIMATION";
export const SET_USER_GAME_DATA = "SET_USER_GAME_DATA";
export const SET_CURRENT_EVAL_TYPE = "SET_CURRENT_EVAL_TYPE";
export const SET_PLAY_GAME = "SET_PLAY_GAME";
export const SET_EXECUTE_PENDING = "SET_EXECUTE_PENDING";
export const SET_EVENT_TYPE_GAME = "SET_EVENT_TYPE_GAME";
export const SET_USER_TITLECARD_PENDING = "SET_USER_TITLECARD_PENDING";
export const SET_USER_TITLECARD = "SET_USER_TITLECARD";
export const SET_IS_QUESTION_REDIRECT = "SET_IS_QUESTION_REDIRECT";
export const SET_CURRENT_GAME_TYPE = "SET_CURRENT_GAME_TYPE";
export const SET_EXECUTE_USER_GAMEDATA = "SET_EXECUTE_USER_GAMEDATA";
export const SET_CURRENT_GAME_TITLE = "SET_CURRENT_GAME_TITLE";
export const GET_GAMEUSER_DATA_PENDING = "GET_GAMEUSER_DATA_PENDING";
export const SET_EUTOEVAL_PROGRESS_STRING = "SET_EUTOEVAL_PROGRESS_STRING";
export const SET_PROGRESS_CLOSE = "SET_PROGRESS_CLOSE";
export const SET_UPLOAD_ETA = "SET_UPLOAD_ETA";
export const IS_OPEN_MATCH_LIST = "IS_OPEN_MATCH_LIST";
